import React, { useEffect } from "react";

import { Controlled as CodeMirror } from "react-codemirror2";
import { CodeEditorProps } from "./props/codeEditorProps";

// tslint:disable: no-require-imports
require("codemirror/lib/codemirror.css");
require("codemirror/theme/material-palenight.css");
require("codemirror/mode/htmlmixed/htmlmixed.js");
require("codemirror/mode/javascript/javascript.js");
require("codemirror/addon/comment/comment.js");
// tslint:enable: no-require-imports

const codemirrorOpts = {
    lineNumbers: true,
    styleActiveLine: true,
    matchBrackets: true
};

export const CodeMirrorEditor = ({
    mode,
    value,
    onChange,
    size,
    errorLine,
    isDarkMode,
    className
}: Omit<CodeEditorProps, "type" | "jsSettings">) => {
    const editorRef: any = React.useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.setOption("extraKeys", {
                "Cmd-/": () => editorRef.current.toggleComment()
            });
        }
    }, []);

    useEffect(() => {
        if (editorRef.current && size) {
            editorRef.current.setSize(size.width, size.height);
        }
    }, [size && size.width, size && size.height]);

    useEffect(() => {
        if (isDarkMode) {
            editorRef.current.setOption("theme", "material-palenight");
        } else {
            editorRef.current.setOption("theme", "default");
        }
    }, [isDarkMode]);

    useEffect(() => {
        if (mode === "js" && editorRef.current && editorRef.current.display.lineDiv) {
            const div: HTMLDivElement = editorRef.current.display.lineDiv;
            div.querySelectorAll(".error-line").forEach(el => el.classList.remove("error-line"));

            if (errorLine) {
                const lines = div.querySelectorAll(".CodeMirror-line");
                const errorLineDiv = lines[errorLine - 2];
                if (errorLineDiv) {
                    errorLineDiv.classList.add("error-line");
                }
            }
        }
    }, [errorLine]);

    return <CodeMirror
        value={value}
        options={{ ...codemirrorOpts, mode: mode === "html" ? "htmlmixed" : "javascript" }}
        onBeforeChange={(_, __, value) => onChange(value)}
        editorDidMount={editor => {
            editorRef.current = editor;
        }}
        className={className}
    />;
};
